import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Switch, Route } from "react-router-dom";

import { setLanguage } from "../actions/languageActions";

//evio component imports
import TC from "./legal/TC";
import Privacy from "./legal/Privacy";
import NotFound from "./static/NotFound";
import InstallationSteps from "./link/InstallationSteps";
import PrivateConditions from "./legalCeme/PrivateConditions";
import GeneralConditions from "./legalCeme/GeneralConditions";

//gocharge component imports
import TCgocharge from "./legal/gocharge/TC";
import Privacygocharge from "./legal/gocharge/Privacy";
import GeneralConditionsGoCharge from "./legalCeme/gocharge/GeneralConditions";
import PrivateConditionsGoCharge from "./legalCeme/gocharge/PrivateConditions";

//hyundai component imports
import TChyundai from "./legal/hyundai/TC";
import Privacyhyundai from "./legal/hyundai/Privacy";

//acp component imports
import TCacp from "./legal/acp/TC";
import Privacyacp from "./legal/acp/Privacy";

//kinto component imports
import TCkinto from "./legal/kinto/TC";
import Privacykinto from "./legal/kinto/Privacy";

import Giveaway from "./giveaway"
import Notifications from "./notifications";
import ChangeEmail from "./changeEmail";



let clientname = "";

const mapStateToProps = (state: {
  i18n: {
    locale: string;
  };
}) => {
  return {
    lang: state.i18n.locale,
  };
};

const mapDispatch = { setLanguage };
const connector = connect(mapStateToProps, mapDispatch);

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps & {
  lang: string;
  locale: string;
  pathname: string;
};

let Router: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.setLanguage(props.locale);
  }, []);


  let fullUrl = window.location.href;

  //swap evio to localhost for testing
  const gocharge = "gocharge";
  const hyundai = "hyundai";
  const acp = "acp";
  const kinto = "kinto";
  if (fullUrl.includes(gocharge)) {
    clientname = gocharge;
  } else if (fullUrl.includes("acp")) {
    clientname = acp;
  } else if (fullUrl.includes("hyundai")) {
    clientname = hyundai;
  } else if (fullUrl.includes("kinto")) {
    clientname = kinto;
  }

  if(props.lang) {
    //the url will accept the lang format and lang_country format
    //for example: /en, /en-US, /pt, /pt-PT, etc.
    const adaptedLang = props.pathname.split('/')[1] || '';

    return (
      <>
        <Switch>
          <Route path={`/${adaptedLang}/terms&conditions`} component={() => clientname === "gocharge" ? < TCgocharge /> 
            : clientname === "hyundai" ? < TChyundai /> 
            : clientname === "acp" ? < TCacp /> 
            : clientname === "kinto" ? < TCkinto /> 
            : <TC />} 
          />
          <Route path={`/${adaptedLang}/privacy`} component={() => clientname === "gocharge" ? < Privacygocharge /> 
            : clientname === "hyundai" ? < Privacyhyundai /> 
            : clientname === "acp" ? < Privacyacp /> 
            : clientname === "kinto" ? < Privacykinto /> 
            : < Privacy />} 
          />
          
          <Route path={`/${adaptedLang}/qrcode`} component={() => <InstallationSteps />} />
          <Route path={`/unsubscribe/`} component={() => < Notifications />} />
          <Route path={`/${adaptedLang}/privateconditions`} component={() => clientname === "gocharge" ? <PrivateConditionsGoCharge /> : <PrivateConditions />} />
          <Route path={`/${adaptedLang}/generalconditions`} component={() => clientname === "gocharge" ? <GeneralConditionsGoCharge /> : <GeneralConditions />} />
          <Route exact path={`/${adaptedLang}/confirmEmail/:hash`} component={ChangeEmail} />
          <Route path={`/${adaptedLang}/regulamento`} component={() => < Giveaway />}
          />
          <Route component={NotFound} />
          

        </Switch>

      </>
    );
  } else{
    return <></>
  }


};

export default connector(Router);
